export default __webpack_public_path__ + "static/media/Oscar_Health_logo.cdbfe803.png";